module.exports = __webpack_public_path__ + "img/md.32899cea.svg";